module.exports = __webpack_public_path__ + "img/1540909790.95aa98f8.jpg";